(function () {
  'use strict';

  document.querySelectorAll('[data-millo-coins-product]').forEach(function (root) {
    if (root.dataset.mediaInitialized) return;
    var configNode = root.querySelector('[data-mcpd-media-config]'), config;
    try { config = JSON.parse(configNode.textContent); } catch (e) { return; }
    var card = root.querySelector('[data-mcpd-media]');
    var poster = root.querySelector('[data-mcpd-media-poster]');
    var video = root.querySelector('[data-mcpd-media-video]');
    var toggle = root.querySelector('[data-mcpd-media-toggle]');
    var fallback = root.querySelector('[data-mcpd-media-fallback]');
    var thumbnails = root.querySelectorAll('[data-mc-thumb]');
    var counter = root.querySelector('[data-mc-index]');
    var progress = root.querySelector('[data-mc-progress]');
    var ambient = root.querySelector('[data-mc-ambient]');
    var visual = root.querySelector('.mcpd-visual');
    if (!card || !poster || !video || !toggle) return;
    root.dataset.mediaInitialized = 'true';

    var packs = config.packs || {}, activeId = '', media = null;
    var userPaused = false, manualPlay = false, failed = false, playPending = false, playSequence = 0;
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : {matches: false};
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var bounds = card.getBoundingClientRect();
    var inView = bounds.bottom > 0 && bounds.top < window.innerHeight;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    function restricted() { return motion.matches || !!(connection && connection.saveData); }
    function desired() { return !!(media && media.video && !userPaused && !failed && !document.hidden && inView && (manualPlay || !restricted())); }
    function label() {
      toggle.textContent = desired()
        ? (config.en ? 'Pause animation' : 'Pausar animación')
        : (config.en ? 'Play animation' : 'Reproducir animación');
    }
    function stop(release) {
      playSequence += 1;
      playPending = false;
      video.pause();
      card.classList.remove('is-playing');
      if (release && video.hasAttribute('src')) {
        video.removeAttribute('src');
        video.load();
      }
    }
    function reconcile() {
      if (!desired()) {
        stop(!media || (restricted() && !manualPlay));
        label();
        return;
      }
      if (video.getAttribute('src') !== media.video) {
        stop(false);
        video.src = media.video;
        video.load();
      }
      label();
      if (playPending || !video.paused) return;
      playPending = true;
      var sequence = ++playSequence;
      var request;
      try { request = video.play(); } catch (e) { rejected(sequence); return; }
      if (request && typeof request.then === 'function') {
        request.then(function () {
          if (sequence !== playSequence) return;
          playPending = false;
          if (desired()) card.classList.add('is-playing');
          else { stop(false); label(); }
        }).catch(function () { rejected(sequence); });
      } else {
        playPending = false;
      }
    }
    function rejected(sequence) {
      if (sequence !== playSequence) return;
      failed = true;
      stop(false);
      label();
    }
    function packInput(id) {
      return Array.prototype.find.call(root.querySelectorAll('input[name="id"]'), function (input) {
        return input.value === id && !input.disabled;
      });
    }
    function selectInput(input) {
      if (!input || input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
    function galleryInputs() {
      return Array.prototype.map.call(thumbnails, function (button) {
        return packInput(button.getAttribute('data-mc-thumb'));
      }).filter(function (input) { return !!input; });
    }
    function galleryStep(direction, available) {
      available = available || galleryInputs();
      if (available.length < 2) return null;
      var index = available.findIndex(function (input) { return input.checked; });
      if (index < 0) return null;
      return available[index + direction] || null;
    }
    function galleryState(id) {
      var index = 0;
      thumbnails.forEach(function (button, i) {
        var active = button.getAttribute('data-mc-thumb') === id;
        button.disabled = !packInput(button.getAttribute('data-mc-thumb'));
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.classList.toggle('is-active', active);
        if (active) index = i + 1;
      });
      if (counter) counter.textContent = String(index || 1).padStart(2, '0');
      if (progress) progress.style.transform = 'translateY(' + (Math.max(0, index - 1) * 100) + '%)';
    }
    function sync() {
      var selected = root.querySelector('input[name="id"]:checked:not(:disabled)');
      var id = selected ? selected.value : '';
      galleryState(id);
      if (id === activeId) { reconcile(); return; }
      activeId = id;
      stop(true);
      failed = false;
      var candidate = Object.prototype.hasOwnProperty.call(packs, id) ? packs[id] : null;
      media = candidate && typeof candidate.poster === 'string' && /^https:\/\//i.test(candidate.poster) ? candidate : null;
      if (typeof config.cutout === 'string' && /^https:\/\//i.test(config.cutout)) media = {poster:config.cutout,video:'',amount:Number(candidate && candidate.amount || selected && selected.dataset.base || 0)};
      card.hidden = !media;
      if (fallback) fallback.hidden = !!media;
      toggle.hidden = !media || !media.video;
      if (ambient) {
        ambient.hidden = !media;
        if (media && ambient.getAttribute('src') !== media.poster) ambient.src = media.poster;
      }
      if (!media) return;
      if (poster.getAttribute('src') !== media.poster) poster.src = media.poster;
      var amount = Number(media.amount || 0).toLocaleString(config.en ? 'en-US' : 'es-ES', {maximumFractionDigits: 0});
      poster.alt = (config.en ? 'Pack of ' : 'Pack de ') + amount + ' Millo Coins';
      video.poster = media.poster;
      bounds = card.getBoundingClientRect();
      inView = bounds.bottom > 0 && bounds.top < window.innerHeight;
      reconcile();
    }

    thumbnails.forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-mc-thumb');
        selectInput(packInput(id));
      });
      button.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 0;
        if (!step) return;
        var available = Array.prototype.filter.call(thumbnails, function (item) {
          return !item.disabled && !!packInput(item.getAttribute('data-mc-thumb'));
        });
        var index = available.indexOf(button);
        if (index < 0 || available.length < 2) return;
        event.preventDefault();
        var next = available[(index + step + available.length) % available.length];
        next.focus();
        next.click();
      });
    });
    if (visual) {
      var desktop = window.matchMedia ? window.matchMedia('(min-width: 981px)') : {matches: false};
      var wheelLock = 0, wheelAccumulated = 0, wheelLast = null, wheelDirection = 0, gestureChanged = false;
      var pointerOver = false;
      visual.addEventListener('wheel', function (event) {
        if (!desktop.matches || event.ctrlKey || event.defaultPrevented) return;
        var delta = event.deltaY;
        if (!Number.isFinite(delta) || delta === 0 || Math.abs(event.deltaX || 0) > Math.abs(delta)) return;
        var available = galleryInputs();
        if (available.length < 2 || !available.some(function (input) { return input.checked; })) return;
        if (event.deltaMode === 1) delta *= 16;
        else if (event.deltaMode === 2) delta *= visual.clientHeight || window.innerHeight;
        var now = performance.now();
        if (wheelLast === null || now - wheelLast > 280) {
          wheelAccumulated = 0;
          wheelDirection = 0;
          gestureChanged = false;
        }
        wheelLast = now;
        var direction = delta > 0 ? 1 : -1;
        var next = galleryStep(direction, available);
        if (!next) {
          // Inertia from the gesture that reached an edge stays in the gallery.
          // A fresh gesture at that edge resumes normal page scrolling.
          if (gestureChanged) event.preventDefault();
          wheelAccumulated = 0;
          return;
        }
        event.preventDefault();
        if (now < wheelLock) return;
        if (wheelDirection !== direction) wheelAccumulated = 0;
        wheelDirection = direction;
        wheelAccumulated += delta;
        if (Math.abs(wheelAccumulated) < 30) return;
        wheelAccumulated = 0;
        wheelLock = now + 900;
        gestureChanged = true;
        selectInput(next);
      }, {passive: false});
      visual.addEventListener('mouseenter', function () { pointerOver = true; });
      visual.addEventListener('mouseleave', function () { pointerOver = false; });
      document.addEventListener('keydown', function (event) {
        if (!desktop.matches || !pointerOver || event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey) return;
        var target = event.target;
        if (target && (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName || ''))) return;
        var direction = event.key === 'ArrowDown' ? 1 : event.key === 'ArrowUp' ? -1 : 0;
        if (!direction) return;
        var next = galleryStep(direction);
        if (!next) return;
        event.preventDefault();
        selectInput(next);
      });
    }
    toggle.addEventListener('click', function () {
      if (desired()) {
        userPaused = true;
        manualPlay = false;
      } else {
        userPaused = false;
        manualPlay = true;
        failed = false;
      }
      reconcile();
    });
    video.addEventListener('playing', function () {
      if (desired()) { card.classList.add('is-playing'); label(); }
      else stop(false);
    });
    video.addEventListener('canplay', function () {
      if (desired() && !video.paused) card.classList.add('is-playing');
    });
    video.addEventListener('error', function () {
      if (!media || !video.hasAttribute('src')) return;
      failed = true;
      stop(true);
      label();
    });
    root.addEventListener('change', function (event) {
      if (event.target.matches('input[name="id"]')) sync();
    });
    window.addEventListener('pageshow', sync);
    window.addEventListener('pagehide', function () { stop(false); });
    document.addEventListener('visibilitychange', reconcile);
    function preferenceChanged() { manualPlay = false; reconcile(); }
    if (motion.addEventListener) motion.addEventListener('change', preferenceChanged);
    else if (motion.addListener) motion.addListener(preferenceChanged);
    if (connection && connection.addEventListener) connection.addEventListener('change', preferenceChanged);
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        reconcile();
      }, {threshold: 0.05}).observe(card);
    }
    sync();
  });
})();
